const reviews = [
  {
    name: "Dr. Rashmi",
    // photo: "https://randomuser.me/api/portraits/men/32.jpg",
    text: "An unforgettable Vietnam tour with M D Tours & Travels—perfectly planned, seamless experiences, and great local insights throughout the journey. From stunning landscapes to vibrant culture, every detail was handled professionally, making the trip truly memorable.",
    rating: 5,
  },
  {
    name: "Ravi",
    // photo: "https://randomuser.me/api/portraits/women/44.jpg",
    text: "A wonderfully organized Vietnam tour by M D Tours & Travels, blending cultural highlights with scenic beauty effortlessly.Excellent coordination and thoughtful planning made the entire trip relaxing and enjoyable.",
    rating: 4,
  },
  {
    name: "Munigowda",
    // photo: "https://randomuser.me/api/portraits/men/28.jpg",
    text: "We had a fantastic Andaman trip with M D Tours & Travels. Everything from hotels to island transfers was perfectly managed, and we truly enjoyed a stress-free, memorable holiday.",
    rating: 5,
  },
  {
    name: "Sneha Rao",
    // photo: "https://randomuser.me/api/portraits/women/68.jpg",
    text: "We booked an adventure tour to Himachal and it was amazing! Everything was well coordinated and safe.",
    rating: 4,
  },
];

export default reviews;
